const testSubmit = async (data: {
  // inviteOption?: string | undefined;
  name: string | undefined;
  email?: string | undefined;
  mobile?: string | undefined;
}): Promise<void> => {
  console.log('data', data);
};

const testEmailSendResponse = (value: boolean) => {
  return value;
};

const checkBoxSelected = (value: string) => {
  return value;
};

const testToastRendered = (value: boolean) => {
  return value;
};

export const TestSubmit = {
  testSubmit,
  testEmailSendResponse,
  checkBoxSelected,
  testToastRendered,
};
